import { createModuleClient } from "./client";

// Les droits qui comptent sont ceux de l'UCT : api-central les tire du binding
// RCS du porteur, et c'est ce jeton que les modules reçoivent. Le scope du
// jeton Keycloak n'en dit rien.

const uctClient = createModuleClient("/api/v1");

function decodePayload(token: string): Record<string, unknown> {
  const part = token.split(".")[1];
  if (!part) return {};
  const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
  const bin = atob(b64.padEnd(Math.ceil(b64.length / 4) * 4, "="));
  const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(bytes)) as Record<string, unknown>;
}

/** Scopes effectifs du porteur, lus dans l'UCT frappé pour lui. Lecture
 * d'affichage seulement : chaque module revérifie la signature et le scope. */
export async function fetchEffectiveScopes(): Promise<string[]> {
  const res = await uctClient.post<{ token: string }>("/uct", {});
  const scopes = decodePayload(res.data.token)["effective_scopes"];
  return Array.isArray(scopes)
    ? scopes.filter((s): s is string => typeof s === "string")
    : [];
}
